module.exports = __webpack_public_path__ + "276852c7ac867e4c02e0161c02b70b4d.svg";